<template>
    <div id="app">
        <v-app>
            <router-view>
            </router-view>
        </v-app>
    </div>
</template>

<script>
export default {
    watch: {
        $route (to, from) {
            if (to.meta.title) {
                document.title = to.meta.title + ' | ' + this.$t('general.company-name')
            } else {
                document.title = this.$t('general.company-name')
            }
        }
    }
}
</script>
